import {Controller} from "stimulus"

// Prints the receipt on screen: to the station's own receipt printer when
// there is one, otherwise by handing off to the browser's print preview.
// A print that fails says so and offers the browser dialog as a way out —
// it never opens one unasked.
export default class extends Controller {
    static targets = ["button", "status", "fallback"]

    print() {
        if (!this.printerAvailable()) {
            this.browserPrint();
            return;
        }
        this.sendToPrinter();
    }

    browserPrint() {
        window.print();
    }

    sendToPrinter() {
        this.startPrinting();
        fetch(this.data.get("url"), {
            method: "POST",
            headers: {
                "X-CSRF-Token": this.csrfToken(),
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            credentials: "same-origin",
            body: JSON.stringify({reprint: this.data.get("reprint") === "true"})
        })
            .then(response => response.json().then(data => ({ok: response.ok, data: data})))
            .then(result => {
                if (result.ok) {
                    this.reportSuccess(result.data.message);
                } else {
                    this.reportFailure(result.data.message, result.data.fallback);
                }
            })
            .catch(() => {
                this.reportFailure("The receipt could not be sent to the printer.", true);
            })
            .then(() => this.finishPrinting());
    }

    startPrinting() {
        this.buttonTarget.disabled = true;
        this.hideFallback();
        this.statusTarget.textContent = "Printing...";
    }

    finishPrinting() {
        this.buttonTarget.disabled = false;
    }

    reportSuccess(message) {
        this.statusTarget.textContent = message;
        this.statusTarget.classList.remove("text-rose-600");
        this.statusTarget.classList.add("text-gray-500");
        this.hideFallback();
    }

    // The teller keeps the paper copy either way: the message says what went
    // wrong and the fallback offers the browser dialog to print it by hand.
    reportFailure(message, fallback) {
        this.statusTarget.textContent = message;
        this.statusTarget.classList.remove("text-gray-500");
        this.statusTarget.classList.add("text-rose-600");
        if (fallback) {
            this.showFallback();
        }
    }

    showFallback() {
        if (this.hasFallbackTarget) {
            this.fallbackTarget.classList.remove("hidden");
        }
    }

    hideFallback() {
        if (this.hasFallbackTarget) {
            this.fallbackTarget.classList.add("hidden");
        }
    }

    printerAvailable() {
        return this.data.get("printerAvailable") === "true";
    }

    csrfToken() {
        const tag = document.querySelector('meta[name="csrf-token"]');
        return tag ? tag.getAttribute("content") : "";
    }
}
